// material-ui
import { useColorScheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';
import useClientConfig from 'hooks/useClientConfig';

import logo from 'assets/images/logo.svg';
import logoDark from 'assets/images/logo-dark.svg';

// ==============================|| LOGO SVG ||============================== //

export default function Logo({ dark = false }: { dark?: boolean }) {
  const { colorScheme } = useColorScheme();
  const clientConfig = useClientConfig();
  const isDark = colorScheme === ThemeMode.DARK || dark;

  const lightLogo = clientConfig.branding.logo || clientConfig.branding.sidebarLogoExpanded;
  const darkLogo = clientConfig.branding.sidebarLogoExpandedDark || clientConfig.branding.sidebarLogoExpanded;
  const brandedLogoSrc = isDark && darkLogo ? darkLogo : lightLogo;

  if (brandedLogoSrc) {
    return (
      <img
        src={brandedLogoSrc}
        alt={clientConfig.branding.appName}
        style={{
          height: '40px',
          width: 'auto',
          maxWidth: '220px',
          objectFit: 'contain',
          display: 'block',
          marginRight: '10px'
        }}
      />
    );
  }

  return (
    <img
      src={isDark ? logoDark : logo}
      alt={clientConfig.branding.appName || 'Logo'}
      style={{ height: '32px', width: 'auto', objectFit: 'contain', display: 'block' }}
    />
  );
}
